import { AlertTriangle, X } from 'lucide-react';
import { useEffect, useState } from 'react';

import useConnectivity from '@/services/connectivityService';

const formatTime = (date) => {
  if (!date) return 'not synced this session';
  try {
    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
    }).format(date);
  } catch {
    return 'recently';
  }
};

const OfflineBanner = () => {
  const { isOnline, lastSyncAt } = useConnectivity();
  const [dismissedAt, setDismissedAt] = useState(null);
  const [showAfterDismissal, setShowAfterDismissal] = useState(false);

  useEffect(() => {
    if (isOnline) {
      setDismissedAt(null);
      setShowAfterDismissal(false);
      return undefined;
    }
    if (!dismissedAt) return undefined;
    const timer = window.setTimeout(() => setShowAfterDismissal(true), 30000);
    return () => window.clearTimeout(timer);
  }, [dismissedAt, isOnline]);

  if (isOnline) return null;
  if (dismissedAt && !showAfterDismissal) return null;

  return (
    <div className="sticky top-0 z-[80] border-b border-red-300 bg-red-50 text-red-900 shadow-sm dark:border-red-800 dark:bg-red-950 dark:text-red-100" role="status" aria-live="polite">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 mt-0.5 shrink-0" />
        <div className="flex-1 text-sm">
          <p className="font-semibold">You're offline — last sync at {formatTime(lastSyncAt)}.</p>
          <p>Some actions are disabled until you reconnect.</p>
        </div>
        <button
          type="button"
          aria-label="Dismiss offline warning"
          className="rounded-full p-1 hover:bg-red-100 dark:hover:bg-red-900"
          onClick={() => {
            setDismissedAt(Date.now());
            setShowAfterDismissal(false);
          }}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default OfflineBanner;
